import React from 'react';
import sharedStyles from './reminderEngineShared.module.css';

type ScheduledEntityCellProps = {
  displayName?: string | null;
  entityType: string;
  entityId: string;
  typeLabel: string;
};

export const ScheduledEntityCell: React.FC<ScheduledEntityCellProps> = ({
  displayName,
  entityType,
  entityId,
  typeLabel,
}) => (
  <div className={sharedStyles.definitionNameCell}>
    <strong>{displayName || entityId}</strong>
    <span className={sharedStyles.definitionKey}>{typeLabel}</span>
    {displayName && displayName !== entityId ? (
      <span className={sharedStyles.entityIdHint}>{entityType}:{entityId}</span>
    ) : null}
  </div>
);
